// extracted by mini-css-extract-plugin
module.exports = {"container":"e_wp","textBadge":"e_xp","buttonBlock":"e_yp"};